
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.171 23.694"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"email(23)"}},[_c('g',{attrs:{"data-name":"Group 1071"}},[_c('path',{attrs:{"data-name":"Path 7195","d":"M23.156 13.709l7.815 9.717a3.552 3.552 0 01-1.354.268H3.554a3.552 3.552 0 01-1.354-.268l7.815-9.717a5.809 5.809 0 004.1 1.692h4.945a5.811 5.811 0 004.1-1.692zM.434 1.853l8.039 9.994-8.039 9.994a3.556 3.556 0 01-.434-1.7V3.554a3.556 3.556 0 01.434-1.701zm32.3 0a3.556 3.556 0 01.434 1.7v16.586a3.556 3.556 0 01-.434 1.7l-8.039-9.994zM2.2.268A3.552 3.552 0 013.554 0h26.063a3.552 3.552 0 011.354.268l-9.235 11.481a3.437 3.437 0 01-2.679 1.283h-4.944a3.437 3.437 0 01-2.679-1.283z","fill":"#3d9ed3","fill-rule":"evenodd"}})])])])
          )
        }
      }
    